import React from "react";
import styled from "styled-components";
import { Form as BootstrapForm, Button } from "react-bootstrap";

const FormWrapper = styled.div`
  text-align: left;
  padding: 1rem;
`;

const Form = (props) => {
  return (
    <FormWrapper>
      <BootstrapForm noValidate validated={props.validated} onSubmit={props.onSubmit}>
        <BootstrapForm.Group controlId="contactFormName" className="mb-3">
          <BootstrapForm.Label>Name</BootstrapForm.Label>
          <BootstrapForm.Control
            type="text"
            name="name"
            placeholder="Enter your name"
            autoComplete="name"
            onChange={props.onChange}
            required
          />
          <BootstrapForm.Control.Feedback type="invalid">
            Please provide a name.
          </BootstrapForm.Control.Feedback>
        </BootstrapForm.Group>
        <BootstrapForm.Group controlId="contactFormEmail" className="mb-3">
          <BootstrapForm.Label>Email address</BootstrapForm.Label>
          <BootstrapForm.Control
            type="email"
            name="email"
            placeholder="Enter your email address"
            autoComplete="email"
            onChange={props.onChange}
            required
          />
          <BootstrapForm.Text className="text-muted">
            Your contact information will only be used to respond to your inquiry.
          </BootstrapForm.Text>
          <BootstrapForm.Control.Feedback type="invalid">
            Please provide a valid email address.
          </BootstrapForm.Control.Feedback>
        </BootstrapForm.Group>
        <BootstrapForm.Group controlId="contactFormSubject" className="mb-3">
          <BootstrapForm.Label>Subject</BootstrapForm.Label>
          <BootstrapForm.Control
            type="text"
            name="subject"
            placeholder="What would you like to discuss?"
            onChange={props.onChange}
          />
        </BootstrapForm.Group>
        <BootstrapForm.Group controlId="contactFormMessage" className="mb-3">
          <BootstrapForm.Label>Message</BootstrapForm.Label>
          <BootstrapForm.Control
            as="textarea"
            rows="5"
            name="message"
            onChange={props.onChange}
            required
          />
          <BootstrapForm.Control.Feedback type="invalid">
            Please provide a message to send.
          </BootstrapForm.Control.Feedback>
        </BootstrapForm.Group>
        <div className="mt-3">
          <Button variant="primary" type="submit" className="me-2">
            Send Message
          </Button>

          <Button variant="secondary" type="reset">
            Reset Form
          </Button>
        </div>
      </BootstrapForm>
        {props.title && <h2>{props.title}</h2>}
        {props.children}
    </FormWrapper>
  );
};

export default Form;
